import Breadcrumb from '../../../../components/base/Breadcrumb';
import PagesHeader from '../../../../components/base/PagesHeader';
import { IBreadCrumb } from '../../../../types/base/BreadCrumb';
import { Col, Row } from 'react-bootstrap';
import CardComponent from '../../../../components/base/CardComponent';
import { SocialTaxChart } from './SocialTaxChart';
import { SocialTaxReport } from './SocialTaxReport';

export const SocialTax = () => {
  const breadcrumb: IBreadCrumb[] = [
    {
      name: 'Overview',
      href: '/dashboard',
    },
    {
      name: 'Reports',
      href: '/reports',
    },
    {
      name: 'Social Tax',
    },
  ];

  return (
    <>
      <Breadcrumb navItem={breadcrumb} />
      <Row className="d-flex">
        <Col md="6">
          <PagesHeader headingClass="fs-h1" pageTitle="Social Tax" />
        </Col>
      </Row>
      <CardComponent>
        <SocialTaxChart />
        <SocialTaxReport />
      </CardComponent>
    </>
  );
};
